module.exports = __webpack_public_path__ + "static/media/crystal_ball_blue.665fa2df.png";